import { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../../hooks/usePageTitle';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import FormInput from '../../components/FormInput/FormInput';
import Button from '../../components/Button/Button';
import api from '../../services/api';
import styles from './ForgotPassword.module.css';

function ForgotPassword() {
  usePageTitle('Forgot password');
  const [email, setEmail]     = useState('');
  const [error, setError]     = useState('');
  const [sent, setSent]       = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { setError('Email is required'); return; }
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <Link to="/login" className={styles.backLink}>
        <span className={styles.backArrow}><ArrowLeft /></span>
        Reset Password
      </Link>

      {sent ? (
        <p className={styles.description}>
          If that email belongs to a POW account, a reset link has been sent. Check your inbox.
        </p>
      ) : (
        <>
          <p className={`${styles.description} mb-4`}>
            Enter the email address associated with your account, and we'll email
            you a link to reset your password.
          </p>
          <form onSubmit={handleSubmit}>
            <FormInput
              id="email"
              label="Email"
              type="email"
              placeholder=""
              value={email}
              onChange={e => { setEmail(e.target.value); setError(''); }}
              error={error}
            />
            <Button type="submit" disabled={loading}>
              {loading ? 'Sending…' : 'Send reset link'}
            </Button>
          </form>
        </>
      )}
    </AuthLayout>
  );
}

export default ForgotPassword;
